import "core-js/modules/es.function.name.js";
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import SimpleModal from 'components/SimpleModal';
import Icon from 'components/Icon';
import Text from 'components/Text';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
function DeletePlaylistModal(_ref) {
  var _ref$isDisabled = _ref.isDisabled,
    isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled,
    name = _ref.name,
    ids = _ref.ids,
    onClose = _ref.onClose,
    onConfirm = _ref.onConfirm;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var count = ids.length;
  var isMultiSelected = count > 1;
  return /*#__PURE__*/_jsx(SimpleModal, {
    title: t('modal_delete_playlist_title', {
      count: count
    }),
    body: /*#__PURE__*/_jsxs(_Fragment, {
      children: [isMultiSelected ? /*#__PURE__*/_jsxs(Trans, {
        t: t,
        i18nKey: "modal_delete_playlist_message",
        values: {
          count: count
        },
        children: ["Do you really want to delete these", ' ', /*#__PURE__*/_jsx("strong", {
          children: count
        }), " playlists?"]
      }) : /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(Text, {
          as: "p",
          children: t('modal_delete_playlist_message')
        }), /*#__PURE__*/_jsxs(Text, {
          as: "p",
          mt: "s",
          bold: true,
          children: [/*#__PURE__*/_jsx(Icon, {
            vAlign: true,
            name: "playlist",
            mr: "xs"
          }), name]
        })]
      }), /*#__PURE__*/_jsx(Text, {
        as: "p",
        mt: "s",
        children: t('modal_delete_playlist_info', {
          count: count
        })
      })]
    }),
    buttons: [{
      isDisabled: isDisabled,
      label: t('actions_cancel'),
      onClick: onClose
    }, {
      isDisabled: isDisabled,
      label: t('actions_delete'),
      onClick: onConfirm,
      variant: 'primary'
    }],
    onClose: onClose
  });
}
export default DeletePlaylistModal;